import { Component, ChangeDetectionStrategy } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PasswordService } from '../services/password.service';

@Component({
  templateUrl: './reset-password-modal.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordModalComponent {
  formGroup = this.fb.group(
    {
      oldPassword: ['', Validators.required],
      newPassword: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /(?=^.{12,20}$)(?=(?:.*?\d){1})(?=.*[a-z])(?=(?:.*?[A-Z]){1})(?=.*[^A-Za-z0-9])(?!.*\s)[0-9a-zA-Z!@#$%*()_+^&]*$/
          ),
        ],
      ],
      newPasswordRepeat: ['', Validators.required],
    },
    { validators: retypedNewPassword }
  );

  get oldPassword() {
    return this.formGroup.get('oldPassword')!;
  }
  get newPassword() {
    return this.formGroup.get('newPassword')!;
  }
  get newPasswordRepeat() {
    return this.formGroup.get('newPasswordRepeat')!;
  }

  constructor(
    public activeModal: NgbActiveModal,
    private passwordService: PasswordService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) {}

  submit() {
    const fv = this.formGroup.value;
    this.passwordService
      .updatePassword({
        oldPassword: fv.oldPassword,
        newPassword: fv.newPassword,
      })
      .subscribe((result) => {
        if (result.success) {
          this.toastr.success('Password updated');
          this.activeModal.close();
        } else {
          this.formGroup.reset();
          this.toastr.error(result.errorText);
        }
      });
  }
}

const retypedNewPassword: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const newPassword = control.get('newPassword');
  const newPasswordRepeat = control.get('newPasswordRepeat');

  return newPassword &&
    newPasswordRepeat &&
    newPassword.value !== newPasswordRepeat.value
    ? { retypedNewPassword: true }
    : null;
};
